import { defineNuxtRouteMiddleware, navigateTo } from 'nuxt/app'
import { useClientStoreRepository } from '@/composables/api/repositories/client-store'
import { useGuestStore } from '~/store/guest'
import { useOnboardStore } from '~/store/onboard'
import { useResetState } from '~/composables/useResetState'

export default defineNuxtRouteMiddleware(async (to) => {
  const { partner, gift } = to.query
  // Gift takes precedence over partner
  // Ignore devtools requests
  if (
    to.path.startsWith('/.well-known/') ||
    import.meta.server ||
    to.meta.skipMiddleware ||
    gift
  ) {
    return
  }

  const guestStore = useGuestStore()

  if (partner) {
    const clientStoreApi = useClientStoreRepository()

    const [partnerName, partnerBrand, partnerRegion] = (
      partner as string
    ).split('.')

    if (guestStore.guest?.store?.partnerName !== partnerName) {
      try {
        const res = await clientStoreApi.execute<'search'>(
          clientStoreApi.search({
            partnerName,
            partnerBrand,
            partnerRegion,
          }),
        )
        const { resetState } = useResetState()
        resetState()

        const { setSwitchCatalogOnboarded } = useOnboardStore()
        setSwitchCatalogOnboarded(false)

        guestStore.setPartnerStoreGuest(res, {
          partnerName,
          partnerBrand,
          partnerRegion,
        })
      } catch (error) {
        const fetchError = clientStoreApi.getError(error)
        if (fetchError?.statusCode === 404) {
          return navigateTo('/welcome', { external: true })
        }
        console.error(fetchError)
      }
    }
  } else if (guestStore.guest?.store?.partnerName && !partner && !gift) {
    // Preserve the partner query param if it's not present but a partner is already loaded
    const partnerId = [
      guestStore.guest?.store?.partnerName,
      guestStore.guest?.store?.partnerBrand,
      guestStore.guest?.store?.partnerRegion,
    ]
      .filter(Boolean)
      .join('.')

    return navigateTo({
      path: to.path,
      query: { ...to.query, partner: partnerId },
    })
  }
})
